angular.module('myApp.controllers')
    .controller('audioVideoResponseCtrl', function ($scope, $timeout, $element, $attrs, $rootScope,
                                                    audioVideoResponse, userMediaStream, clientTools, recordMediaStream,
                                                    speechRecognitionManager, formaters, audioSensitivity, messagesHolder) {
        var qId                                 = $attrs.qid || $scope.audioVideoQId;
        var cameraWrapper                       = $element.find(".camera-image");
        var counter                             = $element.find(".counter");
        var recordTimeLimits                    = recordMediaStream.getRecordTime();
        var leftTimeOfRecording                 = recordTimeLimits.max;
        if (recordTimeLimits.max === 0) {
            //Hide counter. And set long max recording time.
            counter.hide();
            leftTimeOfRecording = 5 * 60;
        }
        var timer                               = null;
        var videoEl                             = null;
        var avatarEl                            = $element.find("img.avatar");
        $scope.error                            = null;
        $scope.isStreamActive                   = false;
        $scope.avatarSrc                        = 'https://' + clientTools.getServerHost() + '/files/avatars/avatar-640.jpg' + '?' + (new Date()).valueOf();

        $scope.devices                          = userMediaStream.getDevices();
        $scope.recordingStatus                  = audioVideoResponse.recordNotActive;
        $scope.sendFileProgress                 = recordMediaStream.sendFileStatuses.inactive;
        $scope.speechRecognitionStatus          = speechRecognitionManager.statuses.done;
        $scope.isAllowStoppingRecord            = false;
        $scope.responseType                     = null;
        if ($scope.devices.video.length && $scope.devices.audio.length) {
            $scope.responseType = audioVideoResponse.typeVideo;
        } else if ($scope.devices.audio.length) {
            $scope.responseType = audioVideoResponse.typeAudio;
        }

        if (!$scope.devices.video.length && !$scope.devices.audio.length) {
            if (!clientTools.isMobileLayout()) {
                $scope.changeResponseType(audioVideoResponse.typeText);
            } else {
                $scope.setAudioVideoQId(null);
            }
        } else {
            audioVideoResponse.setType(qId, $scope.responseType);
        }

        var gotStream = function(stream) {
            $scope.setError(null);
            userMediaStream.setStream(stream, qId);
            return navigator.mediaDevices.enumerateDevices();
        };
        var start = function () {
            stop();
            var constraints = userMediaStream.getConstraints();
            if ($scope.devices.video.length === 0) {
                delete constraints.video;
            }
            if ($scope.devices.audio.length === 0) {
                delete constraints.audio;
            }
            navigator.mediaDevices.getUserMedia(constraints)
                .then(gotStream)
                .then(userMediaStream.setDevices)
                .catch(function(e) {
                    $scope.setError(e);
                });
        };
        var stop = function () {
            userMediaStream.stopStream(qId);
        };
        if ($scope.devices.video.length || $scope.devices.audio.length) {
            start();
        }
        $scope.startUserMedia = function() {
            start();
        };

        $scope.setError = function(err) {
            if (!err) {
                $scope.error = null;
            } else if (typeof err == 'object' && ('name' in err)) {
                var message = messagesHolder.getMessages(err.name);
                if (!message) {
                    message = messagesHolder.getMessages('NotReadableError');
                }
                $timeout(function() {
                    $scope.error = message;
                }, 1);
            } else {
                $timeout(function() {
                    $scope.error = err;
                }, 1);
            }
        };

        var checkTimeLimit  = function() {
            $timeout(function() {
                $scope.isAllowStoppingRecord = recordTimeLimits.min <= recordTimeLimits.max - leftTimeOfRecording;
            }, 1);
            if (leftTimeOfRecording > 0) {
                counter.html(formaters.formatDuration(leftTimeOfRecording));
                if (recordMediaStream.timeInterval && leftTimeOfRecording % recordMediaStream.timeInterval == 0) {
                    recordMediaStream.requestRecordedData(qId, audioVideoResponse.getType(qId));
                }
            } else if ($scope.isAllowStoppingRecord) {
                $scope.stopRecordStream();
                resetTimer();
            }
        };
        var startTimer      = function() {
            if (!timer) {
                if (leftTimeOfRecording > 0) {
                    counter.html(formaters.formatDuration(leftTimeOfRecording));
                }
                timer = setInterval(function() {
                    leftTimeOfRecording -= 1;
                    checkTimeLimit();
                }, 1000);
            }
        };
        var stopTimer       = function() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        };
        var resetTimer      = function() {
            stopTimer();
            leftTimeOfRecording = recordTimeLimits.max;
            if (recordTimeLimits.max === 0) {
                //Hide counter. And set long recording time.
                leftTimeOfRecording = 5 * 60;
            }
            $scope.isAllowStoppingRecord = false;
        };
        var stopPlaying     = function() {
            $timeout(function() {
                $scope.isStreamActive = false;
                if (videoEl) {
                    videoEl.trigger("pause");
                }
                resetTimer();
            }, 1);
        };
        var topBlock = $element.find(".select-list");
        var changeHeightOfVideo = function() {
            if (clientTools.isMobileLayout()) {
                var topBlockHeight  = topBlock.height();
                var width           = $element.width();
                var height          = $element.height();
                var remainHeight    = height - topBlockHeight - 60;
                var responseType    = audioVideoResponse.getType(qId);

                if (width > height) {
                    //Landscape
                    if (responseType == audioVideoResponse.typeVideo) {
                        if (videoEl && videoEl.length) {
                            videoEl.prop("style", 'height: '+remainHeight+'px;width: auto;');
                        }
                        avatarEl.hide();
                    } else if (responseType == audioVideoResponse.typeAudio) {
                        if (videoEl && videoEl.length) {
                            videoEl.hide();
                        }
                        avatarEl.prop("style", 'height: '+remainHeight+'px;width: auto;');
                    }
                } else {
                    //Portrait
                    if (responseType == audioVideoResponse.typeVideo) {
                        if (videoEl && videoEl.length) {
                            videoEl.prop("style", 'height: '+(width/1.3333)+'px;width: '+width+'px;');
                        }
                        avatarEl.hide();
                    } else if (responseType == audioVideoResponse.typeAudio) {
                        if (videoEl && videoEl.length) {
                            videoEl.hide();
                        }
                        avatarEl.prop("style", 'height: '+(width/1.3333)+'px;width: '+width+'px;');
                    }
                }
            }
        };
        $scope.$on("userMediaStreamAdded", function(e, data) {
            if (data && data.qId == qId) {
                resetTimer();
                var responseType = audioVideoResponse.getType(qId);
                recordMediaStream.resetRecorders(qId);
                var stream = userMediaStream.getStream(qId);
                if (stream) {
                    if (videoEl) {
                        videoEl.remove();
                    }
                    videoEl = $("<video></video>");
                    var constraints = userMediaStream.getConstraints();
                    var width = !clientTools.isMobileLayout() ? constraints.video.width : $element.width();
                    var height = !clientTools.isMobileLayout() ? constraints.video.height : (width / 1.33333);

                    videoEl.prop({
                            muted: true,
                            width: parseInt(width),
                            height: parseInt(height),
                        }
                    );
                    try {
                        videoEl.prop({srcObject: stream});
                    } catch (e) {
                        videoEl.prop({src: URL.createObjectURL(stream)});
                    }

                    videoEl.on("play", function () {
                        videoEl.off("play");
                        $timeout(function () {
                            $scope.isStreamActive = true;
                        }, 1);
                    });
                    cameraWrapper.append(videoEl);
                    if (responseType == audioVideoResponse.typeAudio) {
                        videoEl.hide();
                    }
                    cameraWrapper.addClass(userMediaStream.getDefaultVideoSize());
                    $timeout(function () {
                        videoEl.trigger("play");
                    }, 100);
                    var checkPlaying = setTimeout(function() {
                        if (!videoEl.get(0).currentTime) {
                            $scope.startUserMedia();
                        } else {
                            changeHeightOfVideo();
                        }
                        clearTimeout(checkPlaying);
                    }, 3000);
                }
            }
        });
        $(window).on("resize.player", changeHeightOfVideo);
        changeHeightOfVideo();

        $scope.recordStream = function() {
            if ($scope.isStreamActive && $scope.recordingStatus == audioVideoResponse.recordNotActive) {
                var stream = userMediaStream.getStream(qId);
                if (stream && videoEl) {
                    var responseType = audioVideoResponse.getType(qId);
                    recordMediaStream.startRecording(stream, responseType, qId, videoEl.get(0));
                    startTimer();
                }
            }
        };
        $scope.stopRecordStream = function() {
            if ($scope.isStreamActive && $scope.isAllowStoppingRecord &&
                ($scope.recordingStatus == audioVideoResponse.recordActive || $scope.recordingStatus == audioVideoResponse.recordPaused)) {
                recordMediaStream.stopRecording(qId);
                stop();
                stopPlaying();
                if (videoEl) {
                    videoEl.off();
                }
            }
        };
        $scope.pauseRecordStream = function() {
            if ($scope.isStreamActive && $scope.recordingStatus == audioVideoResponse.recordActive) {
                recordMediaStream.pauseRecording(qId);
                stopTimer();
            }
        };
        $scope.resumeRecordStream = function() {
            if ($scope.isStreamActive && $scope.recordingStatus == audioVideoResponse.recordPaused) {
                recordMediaStream.resumeRecording(qId);
                startTimer();
            }
        };
        $scope.$on("recordedFilesProgress", function (e, data) {
            if (data && ('qId' in data) && data.qId == qId && ('status' in data)) {
                $timeout(function () {
                    $scope.sendFileProgress = data.status;
                }, 1);
            }
        });
        $scope.$on("speechRecognitionStatus", function (e, data) {
            if (data && ('qId' in data) && data.qId == qId && ('status' in data)) {
                $scope.speechRecognitionStatus = data.status;
            }
        });
        $scope.$on("recordingStatusChanged", function (e, data) {
            if (data && ('qId' in data) && data.qId == qId) {
                $scope.recordingStatus = recordMediaStream.getRecordingStatus(qId);
            }
        });
        $scope.$on("userMediaError", function(e, data) {
            if (data && ('err' in data)) {
                $scope.setError(data.err);
            }
        });

        $scope.$on("startUserMedia", function (e, data) {
            start();
        });

        $scope.isAudioProblem = false;
        $scope.$on("audioCheckStatus", function (e, data) {
            if (data && ('qId' in data) && data.qId == qId) {
                if (data.status < audioSensitivity.statuses.ok) {
                    $scope.isAudioProblem = true;
                } else {
                    $scope.isAudioProblem = false;
                }
            }
        });

        $scope.resetRecorders = function() {
            recordMediaStream.resetRecorders(qId);
        };

        $scope.$on("$destroy", function() {
            stop();
            stopPlaying();
            if (videoEl) {
                videoEl.off();
            }
            $(window).off("resize.player");
        });
    });